import React from 'react';
import { useLocaleContext } from '../../../../context/LocaleContext';
import { CButton } from '../../../UI';

import './style.scss';

const ScheduleFiltersHalls = ({selectedHall, halls, onChange}) => {
    const $locale = useLocaleContext();

    // if (halls?.length <= 1) {
    //     return null;
    // }

    return (
        <div className="schedule-filters-halls">
            <CButton
                size="lg"
                label={$locale.get('label.all')}
                theme={!selectedHall ? 'highlight' : 'default'}
                onClick={() => onChange(null)}
            />
            {
                halls?.map((hall) => (
                    <CButton
                        key={hall.id}
                        size="lg"
                        color={!!hall.color ? hall.color ?? '' : ''}
                        colorFilled={selectedHall === hall.id ? (hall.color || "var(--app-color-3)") : ''}
                        label={$locale.getProperty(hall, 'description')}
                        onClick={() => onChange(hall.id)}
                    />
                ))
            }
        </div>
    )
};

export default ScheduleFiltersHalls;
